import classNames from "classnames"
// import dynamic from "next/dynamic"
import ParagraphsContainer from "./ParagraphsContainer"
import ParagraphsTemplate from "./PargaraphsTemplate"
import ParagraphsMultiple from "./PargaraphsMultiple"

// const ParagraphsContainer = dynamic(() => import("./ParagraphsContainer"))
// const ParagraphsTemplate = dynamic(() => import("./pargaraphs.template"))
// const ParagraphsMultiple = dynamic(() => import("./pargaraphs.multiple"))
// import DF_DEV_MAPPING from "../../next/.tmp/widgets.dev.json"
import DF_DEV_MAPPING from "@/runtime/widgets.dev.json"

export const ParagraphsController = (props) => {
	const { hasAMP = false } = props
	const {
		type,
		paragraph_identifier,
		paragraph_container,
		paragraph_section,
		paragraph_css_class,
		field_background_color = null,
		field_vactory_component = null,
		field_vactory_paragraph_tab = null,
		paragraph_background_image = null,
		field_vactory_flag = false,
		field_paragraph_hide_lg = false,
		field_paragraph_hide_sm = false,
		field_size_image = null,
		field_position_image_x = null,
		field_position_image_y = null,
		container_spacing = null,
		paragraph_background_parallax = false,
	} = props.data

	const backgroundColor =
		field_background_color?.color?.hexadecimal !== "#FF0000"
			? field_background_color?.color?.hexadecimal
			: null
	const backgroundImage = paragraph_background_image
		? `url(${paragraph_background_image.thumbnail.uri.value._default})`
		: null

	let childComponent

	if (type === "paragraph--vactory_component" && field_vactory_component) {
		const df_dev_template_file =
			process &&
			process.env.NODE_ENV === "development" &&
			DF_DEV_MAPPING[field_vactory_component.widget_id]
				? DF_DEV_MAPPING[field_vactory_component.widget_id]
				: ""
		childComponent = (
			<div
				data-df-id={field_vactory_component.widget_id}
				data-df-template={df_dev_template_file}
			>
				<ParagraphsTemplate
					id={field_vactory_component.widget_id}
					hasAMP={hasAMP}
					settings={JSON.parse(field_vactory_component.widget_data)}
					showTitle={field_vactory_flag}
					title={props.data.field_vactory_title}
				/>
			</div>
		)
	} else if (
		type === "paragraph--vactory_paragraph_multi_template" &&
		field_vactory_paragraph_tab
	) {
		childComponent = (
			<ParagraphsMultiple
				type={props.data.field_multi_paragraph_type}
				title={props.data.field_vactory_title}
				showTitle={field_vactory_flag}
				introduction={props.data.field_paragraph_introduction}
				cta={props.data.field_paragraphs_cta}
				tabs={field_vactory_paragraph_tab}
				hasAMP={hasAMP}
			/>
		)
	}

	return (
		<ParagraphsContainer
			id={paragraph_identifier}
			layout={paragraph_container}
			state={paragraph_section}
			spacing={container_spacing}
			style={{
				backgroundColor: backgroundColor,
				backgroundImage: backgroundImage,
			}}
			className={classNames("paragraph", type, paragraph_css_class)}
			hideOnDesktop={field_paragraph_hide_lg}
			hideOnMobile={field_paragraph_hide_sm}
			backgroundSize={field_size_image}
			backgroundPositionX={field_position_image_x}
			backgroundPositionY={field_position_image_y}
			activateParallax={paragraph_background_parallax}
		>
			{childComponent}
		</ParagraphsContainer>
	)
}
